import React from 'react';
import { FormControl, FormHelperText } from '@material-ui/core';
import { Select } from '@backstage/core-components';
import useRelatedGroupPicker from './hooks';

export const RelatedGroupPickerSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      dependentFields: {
        type: 'array',
        items: {
          type: 'string',
        },
      },
    },
  },
  returnValue: { type: 'object' },
};

export const RelatedGroupPicker = (props: any) => {
  const { onChange, schema, required, formData, formContext } = props;
  const systemRef = formContext.formData?.system;
  const projectRefs = formContext.formData?.projects;

  const { options } = useRelatedGroupPicker(
    systemRef,
    projectRefs,
    formData,
    onChange,
  );

  return (
    <FormControl
      margin="normal"
      required={required}
      error={required && (!formData || formData.length === 0)}
    >
      <Select
        label={schema.title}
        placeholder="Select one or more groups"
        items={options}
        multiple
        onChange={value => {
          if (Array.isArray(value)) {
            onChange(value);
          }
        }}
        selected={formData || []}
      />
      {schema.description && (
        <FormHelperText>{schema.description}</FormHelperText>
      )}
    </FormControl>
  );
};
